// English strings (source language): a ride interrupted by a closed or reloaded page, picked up again (ADR 0028).

const en = {
  title: 'Pick up where you left off?',
  titleOver: 'Your last ride was interrupted',
  /** Tiles of the dialog: the time and distance ridden, and how long ago the page stopped sending. */
  kRidden: 'ridden',
  kDistance: 'distance',
  kStopped: 'stopped',
  justNow: 'just now',
  minutesAgo: (n: number) => (n === 1 ? '1 minute ago' : `${n} minutes ago`),
  hoursAgo: (n: number) => (n === 1 ? '1 hour ago' : `${n} hours ago`),
  helpResume: 'The ride goes on where it stopped: same recording, same clock, same distance.',
  helpWorkout: 'The workout goes on in the block you were in, with the compliance you had.',
  helpRace: 'A race against bots cannot go on: its riders only lived in the page that closed. Keep what you rode in your history, or drop it.',
  helpOnline: 'The online race went on without you. Keep what you rode in your history, or drop it.',
  helpLater: 'Not now? The ride is saved by itself when you start the next one.',
  resume: 'Continue the ride',
  save: 'Save the ride',
  discard: 'Discard',
  discardTitle: 'Discard this ride?',
  discardHelp: 'It will not appear in your history and will not count toward your progress. This cannot be undone.',
  discardYes: 'Discard for good',
  keep: 'Keep it',
  saved: (xp: number) => `Ride saved · +${xp} XP`,
  discarded: 'Ride discarded',
  failed: 'The ride could not be reached. It stays safe on the server: try again in a moment.',
  welcomeBack: (dur: string) => `Welcome back: the ride goes on from ${dur}`,
  rejoining: 'Back to your online race…',
  rejoined: 'Back in the race',
  rejoinFailed: 'The room could not hold your place any longer.',
};
export default en;
